export default "__VITE_ASSET__eaa99409__"